import * as types from './form.actionType';

export default {
  inserted: (message) => ({
    type: types.FORM_INSERTED_SUCCESS,
    payload: message,
  }),
  insertedNoScroll: (message) => ({
    type: types.FORM_INSERTED_SUCCESS_NOSCROLL,
    payload: message,
  }),
  updated: (message) => ({
    type: types.FORM_UPDATED_SUCCESS,
    payload: message,
  }),
  updatedNoScroll: (message) => ({
    type: types.FORM_UPDATED_SUCCESS_NOSCROLL,
    payload: message,
  }),
  deleted: (message) => ({
    type: types.FORM_DELETED_SUCCESS,
    payload: message,
  }),
  deletedNoScroll: (message) => ({
    type: types.FORM_DELETED_SUCCESS_NOSCROLL,
    payload: message,
  }),
  associate: (message) => ({
    type: types.FORM_ASSOCIATE_SUCCESS,
    payload: message,
  }),
  massAssociate: (message) => ({
    type: types.FORM_MASSASSOCIATE_SUCCESS,
    payload: message,
  }),
  disassociate: (message) => ({
    type: types.FORM_DISASSOCIATE_SUCCESS,
    payload: message,
  }),
  disassociateNoScroll: (message) => ({
    type: types.FORM_DISASSOCIATE_SUCCESS_NOSCROLL,
    payload: message,
  }),
  cancel: (message) => ({
    type: types.FORM_CANCEL_SUCCESS,
    payload: message,
  }),
  reactivate: (message) => ({
    type: types.FORM_REACTIVATE_SUCCESS,
    payload: message,
  }),
  redirect: (name, parameters) => ({
    type: types.FORM_REDIRECT,
    payload: {
      name,
      parameters,
    },
  }),
  deferido: () => ({
    type: types.FORM_DEFERIDO,
  }),
  redirectUrl: (url) => ({
    type: types.FORM_REDIRECT,
    payload: {
      url,
    },
  }),
  reload: () => ({
    type: types.FORM_RELOAD,
  }),
  formActionReset: () => ({
    type: types.FORM_RESET,
  }),
  gridReload: (uid) => ({
    type: types.FORM_GRID_RELOAD,
    payload: uid,
  }),
  gridReset: (uid) => ({
    type: types.FORM_GRID_RESET,
    payload: uid,
  }),
  treeviewReload: (uid) => ({
    type: types.FORM_TREEVIEW_RELOAD,
    payload: uid,
  }),
  integration: (message) => ({
    type: types.FORM_INTEGRATION_SUCCESS,
    payload: message,
  }),
  rejection: (message) => ({
    type: types.FORM_REJECTION_SUCCESS,
    payload: message,
  }),
  gerado: (message) => ({
    type: types.FORM_GERADO_SUCCESS,
    payload: message,
  }),
  exigencia: (message) => ({
    type: types.FORM_EXIGENCIA_SUCCESS,
    payload: message,
  }),
  ignore: (message) => ({
    type: types.FORM_IGNORE_SUCCESS,
    payload: message,
  }),
  reactivated: (message) => ({
    type: types.FORM_REACTIVED_SUCCESS,
    payload: message,
  }),
  resetForm: (uid) => ({
    type: types.RESET_FORM,
    payload: uid,
  }),
  resetHashForm: (uid) => ({
    type: types.RESET_HASH_FORM,
    payload: uid,
  }),
  cancelar: () => ({
    type: types.FORM_CANCELAR,
  }),
  cientizar: () => ({
    type: types.FORM_CIENTIZAR,
  }),
  erro: (msg) => ({
    type: types.FORM_ERRO,
    payload: msg,
  }),
  warning: (msg) => ({
    type: types.FORM_WARNING,
    payload: msg,
  }),
  info: (msg) => ({
    type: types.FORM_INFO,
    payload: msg,
  }),
  setSelectedItens: (itens, hash) => ({
    type: types.FORM_GRID_SET_SELECTEDITENS,
    payload: { itens, hash },
  }),
  resetFormControl: (uid) => ({
    type: types.RESET_FORMCONTROL,
    payload: uid,
  }),
  imageInserted: (message) => ({
    type: types.IMAGE_INSERTED_SUCCESS,
    payload: message,
  }),
  imageRemoved: (message) => ({
    type: types.IMAGE_REMOVED_SUCCESS,
    payload: message,
  }),
  aprovado: () => ({
    type: types.FORM_APROVADO_SUCCESS,
  }),
  cancelado: () => ({
    type: types.FORM_CANCELADO_SUCCESS,
  }),
  recusado: () => ({
    type: types.FORM_RECUSADO_SUCCESS,
  }),
};
